export enum TradeAllocStatus {
  /** Pending clear */
  PendingClear = 0,
  /** Claimed */
  Claimed = 1,
  /** Cleared */
  Cleared = 2,
  /** Rejected */
  Rejected = 3,
}
